// Tema claro/escuro da Agenda e do app do funcionário no celular — mesma
// preferência nos dois (AgendaShell e FuncionarioMobileShell), aplicada
// como classe `dark` no <html>. Padrão: escuro no computador (pedido
// 2026-09-13), claro no celular (pedido 2026-10-09: "tá ficando só no
// fundo escuro").
export const AGENDA_THEME_KEY = "gpsdrive:agenda-theme-mode";

export function readAgendaThemeIsDark(): boolean {
  const phone = typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches;
  try {
    const stored = localStorage.getItem(AGENDA_THEME_KEY);
    return stored ? stored === "dark" : !phone;
  } catch {
    return !phone;
  }
}

export function applyAgendaTheme(dark: boolean) {
  const root = document.documentElement;
  if (dark) root.classList.add("dark");
  else root.classList.remove("dark");
  try {
    localStorage.setItem(AGENDA_THEME_KEY, dark ? "dark" : "light");
  } catch {
    // localStorage indisponível — só não persiste a preferência
  }
}

// Admin no app (pedido 2026-10-15): entra na Agenda pela aba do app e volta
// depois — guarda o tema do app pra restaurar na volta (a Agenda aplica o
// dela no <html>).
const APP_THEME_KEY = "gpsdrive:app-theme-before-agenda";

export function rememberAppTheme() {
  try {
    sessionStorage.setItem(APP_THEME_KEY, document.documentElement.classList.contains("dark") ? "dark" : "light");
  } catch {
    // sem sessionStorage — na volta fica o tema da Agenda
  }
}

export function restoreAppTheme() {
  try {
    const v = sessionStorage.getItem(APP_THEME_KEY);
    if (v) document.documentElement.classList.toggle("dark", v === "dark");
  } catch {
    // idem
  }
}
